import MoVeInDesktopFooter from './MoVeInDesktopFooter';
export default MoVeInDesktopFooter;
